import { Action } from '@ngrx/store'
import { AuthenticationResult, SessionInfo } from 'src/data/authentication-info';
/**
 * Created by ashok on 10/05/17.
 */

export function createAction(type: string, payload?: any) {
    return {
        type: type,
        payload: payload
    };
};



export class GetLoginSuccess implements Action {
    readonly type = 'PLAYER_LOGGED_IN';
    constructor(public payload: SessionInfo) { }
}
